import { useMutation, useQueryClient } from 'react-query';
import { useMemo } from 'react';
import { ApiVehicleProfile, VehicleProfileUpdatePayload } from '~/api/types';
import VehicleProfileApi from '~/api/VehicleProfileApi';

interface UseFetchVehicleProfilesProps {
    queryKey: string;
}

export const useUpdateVehicleProfile = ({
    queryKey
}: UseFetchVehicleProfilesProps) => {
    const updateVehicleProfile = async ({
        id,
        payload
    }: {
        id: string;
        payload: VehicleProfileUpdatePayload;
    }): Promise<ApiVehicleProfile> => {
        const {
            data: { data }
        } = await VehicleProfileApi.put(id, payload);
        return data;
    };

    const queryClient = useQueryClient();

    const { isLoading, isError, isSuccess, mutateAsync, data } = useMutation(
        updateVehicleProfile,
        {
            onSuccess: () => {
                return queryClient.invalidateQueries(queryKey);
            }
        }
    );

    return useMemo(() => {
        const vehicleProfile = data ?? null;

        return {
            isError,
            isLoading,
            isSuccess,
            mutateAsync,
            vehicleProfile
        };
    }, [data, isError, isLoading, isSuccess, mutateAsync]);
};
